module.exports = __webpack_public_path__ + "img/A11_2.51361375.png";